import { render, staticRenderFns } from "./AdminAdditionalIncome.vue?vue&type=template&id=78f2b0f9&"
import script from "./AdminAdditionalIncome.vue?vue&type=script&lang=js&"
export * from "./AdminAdditionalIncome.vue?vue&type=script&lang=js&"
import style0 from "./AdminAdditionalIncome.vue?vue&type=style&index=0&id=78f2b0f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports